import { render, staticRenderFns } from "./LandingTestimonial.vue?vue&type=template&id=1e1fba50&scoped=true"
import script from "./LandingTestimonial.vue?vue&type=script&lang=js"
export * from "./LandingTestimonial.vue?vue&type=script&lang=js"
import style0 from "./LandingTestimonial.vue?vue&type=style&index=0&id=1e1fba50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1fba50",
  null
  
)

export default component.exports